export function formatAddress(addr) {
  if (!addr) return '';
  const lines = [];
  if (addr.recipientName) lines.push(addr.recipientName);
  if (addr.streetAddress) lines.push(addr.streetAddress);
  const cityLine = [addr.city, addr.region, addr.postalCode].filter(Boolean).join(', ');
  if (cityLine) lines.push(cityLine);
  if (addr.country) lines.push(addr.country);
  return lines.join('\n');
}

